"use strict";

var config = require("app/util/config/config");
var APICaller = require("./api-caller");

var paymentAPI = new APICaller(config.app.apiURL);

paymentAPI.getPlans = function getPlans(callback, params) {
  var options = {
    success: function(response) {
      callback(null, response);
    },
    error: function(err) {
      callback(err, null);
    }
  };
  this.get("/plans", params, options);
};

paymentAPI.getFreePlan = function getFreePlan(callback) {
  // TODO we have to change the API to fix group gratuito behaviour
  //this.get("/plans", { group: "gratuito" },
  //  {
  //    success: function(response) {
  //      callback(null, response);
  //    },
  //    error: function(err) {
  //      callback(err, null);
  //    }
  //  }
  //);

  var fakeResponse = {
    body: {
      "planId": 1,
      "name": "Gratuito",
      "value": 0,
      "active": 1,
      "description": "Plano Gratuito. Até 2 usuários.",
      "group": "gratuito",
      "maxUsers": 2,
      "maxOrganizations": 1000,
      "maxPeople": 1000,
      "maxDeals": 150,
      "pipeline": 0,
      "category": 0,
      "privacy": 0,
      "sector": 0,
      "trimestralDiscountId": 1,
      "semestralDiscountId": 2,
      "anualDiscountId": 3,
      "defaultValue": 0,
      "trimestralValue": 0,
      "semestralValue": 0,
      "anualValue": 0
    }
  };
  callback(fakeResponse);
};

paymentAPI.getPlanByID = function getPlanByID(callback, id) {
  var options = {
    success: function(response) {
      callback(null, response);
    },
    error: function(err) {
      callback(err, null);
    }
  };
  this.get("/plans/"+id, {}, options);
};

module.exports = paymentAPI;



// WEBPACK FOOTER //
// ./app/util/api/payment-api.js